import { useTranslation } from 'react-i18next';
import { Body, Copy } from 'app/components/Typography';
import useFeatureFlags, { UiRefreshNoResultsPageVersion } from 'app/hooks/useFeatureFlags';

export default function TailorNoResults({ query }: { query?: string }) {
  const flags = useFeatureFlags();

  switch (flags.uiRefreshNoResultsPageVersion) {
    case UiRefreshNoResultsPageVersion.V1:
      return <NoResultsPageV1 query={query} />;
    case UiRefreshNoResultsPageVersion.V2:
    default:
      return <NoResultsPageV2 query={query} />;
  }
}

const NoResultsPageV1 = ({ query }: { query?: string }) => {
  const { t } = useTranslation();
  return (
    <>
      <Copy className="text-typography-copy">{t('no_results_found_v1', { query })}</Copy>
    </>
  );
};

const NoResultsPageV2 = ({ query }: { query?: string }) => {
  const { t } = useTranslation();
  return (
    <>
      <Copy className="mb-8 text-typography-copy">{t('no_results_found', { query })}</Copy>
      <Body className="mb-4 text-typography-heading">{t('search_tips')}</Body>
      <ul className="list-disc pl-4">
        <Copy
          className="mb-4 text-typography-heading"
          component="li"
        >
          {t('check_spelling')}
        </Copy>
        <Copy
          className="mb-4 text-typography-heading"
          component="li"
        >
          {t('use_different_keywords')}
        </Copy>
        <Copy
          className="mb-4 text-typography-heading"
          component="li"
        >
          {t('use_specific_terms')}
        </Copy>
      </ul>
    </>
  );
};
